import axios from "axios";
import {
  ADMIN_DASHBOARD_SUMMARY,
  ADMIN_INVESTOR_LIST,
  ADMIN_INVESTOR_LIST_EXPORT,
  ADMIN_INVESTMENT_LIST,
  ADMIN_TRANSACTION_LIST,
  CUSTOMER_LIST,
  RM_LIST,
  FAQ_LIST,
  FAQ_DETAIL,
  SUPPORT_LIST,
  SUPPORT_SHOW,
  SUPPORT_DETAIL,
  SUPPORT_CLOSE,
  RM_ASSIGN_LIST,
  RM_DETAIL,
  ADMIN_MAILBACK,
  CUSTOMER_STATUS_LIST,
  RM_BANK_LIST,
  ADMIN_EMAIL_UPDATE,
  ADMIN_MOBILE_UPDATE,
  USER_FORGOT_PASSWORD,
  ADMIN_INVESTOR_ADD,
  ADMIN_INVESTOR_DETAIL,
  ADMIN_RESUBMIT_PROFILE,
  ADMIN_ADD_INVESTOR_DATA,
  ADMIN_EDIT_INVESTOR_DATA,
  ADMIN_FATCA_DATA,
  ADMIN_FATCA_LINK,
  ADMIN_IIN_LINK,
  ADMIN_CHECK_BROKER,
  BANK_DETAIL_IFSC,
  ADMIN_INVESTMENT_AMC,
  ADMIN_INVESTMENT_INVESTOR,
  ADMIN_INVESTMENT_FUND,
  ADMIN_INVESTMENT_CART_PRODUCT_BUY,
  ADMIN_INVESTMENT_CART_PRODUCT_DELETE,
  ADMIN_INVESTMENT_CART_PRODUCT_PROCEED,
  ADMIN_INVESTMENT_CART_PRODUCT_SHOW,
  ADMIN_INVESTMENT_CART_PRODUCT_ADD,
  ADMIN_DASHBOARD_AUM_SUMMARY,
  PURCHASE_CART,
} from "./types";
import {
  getLocalStorageUserToken,
  getLocalStorageUserData,
} from "../utils/userData";
import axiosInstance from "../api/axios";
import { toast } from "react-toastify";
import { getHeaderCount } from "./notificationAction";

const token = getLocalStorageUserToken();
const userData = getLocalStorageUserData();
export const dashboardSummary = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/dashboard`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({
        type: ADMIN_DASHBOARD_SUMMARY,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      dispatch({
        type: ADMIN_DASHBOARD_SUMMARY,
        error: error.message,
      });
      console.error("Error fetching Dashboard Valuation Data:", error.message);
      return error;
    }
  };
};

export const investorList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/list?per_page=${payload?.per_page}&page_num=${payload?.page_num}&rmid=${payload?.rmId}&search=${payload?.search}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_INVESTOR_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_INVESTOR_LIST, error: error.message });
      console.error("Error fetching Investor List:", error.message);
      return error;
    }
  };
};

export const investorListExport = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/export?rmid=${payload?.rmId}&search_value=${payload?.search}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_INVESTOR_LIST_EXPORT, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_INVESTOR_LIST_EXPORT, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const investorIINExport = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/getInstaIINReport?customer_id=${payload?.userId}&from_date=${payload?.startDate}&to_date=${payload?.endDate}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_TRANSACTION_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_TRANSACTION_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const investmentList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investments/list?perpage=${payload?.per_page}&pagenum=${payload?.page_num}&search=${payload?.search}&type=${payload?.type}&subtype=${payload?.subType}&rmid=${payload?.rmid}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_INVESTMENT_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_INVESTMENT_LIST, error: error.message });
      console.error("Error fetching Investment List:", error.message);
      return error;
    }
  };
};

export const transactionList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/transactions/recent_trxn`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_TRANSACTION_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_TRANSACTION_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const investmentListExport = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investments/export?user_id=${payload?.userId}&start_date=${payload?.startDate}&end_date=${payload?.endDate}&rm_id=${payload?.rmId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_TRANSACTION_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_TRANSACTION_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const transactionListExport = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/transactions/export?user_id=${payload?.userId}&start_date=${payload?.startDate}&end_date=${payload?.endDate}&rm_id=${payload?.rmId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_TRANSACTION_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_TRANSACTION_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const customerListExport = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        // `${process.env.REACT_APP_API_URL}admin/report/getCustomersList?page_name=${payload.page}`,
        // `${process.env.REACT_APP_API_URL}admin/reports/getCustomersList`,
        `${process.env.REACT_APP_API_URL}admin/investments/getInvestors`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: CUSTOMER_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: CUSTOMER_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const rmUserList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager?per_page=${payload?.per_page}&page_num=${payload?.page_num}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

/* done new flow */
export const faqList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}faq/get?search=${payload?.search}&limit=${payload?.per_page}&page=${payload?.page_num}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: FAQ_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: FAQ_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const faqAdd = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}faq/create`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: FAQ_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: FAQ_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const faqEdit = (payload, id) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_URL}faq/update/${id}`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: FAQ_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: FAQ_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const faqDelete = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}faq/delete/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: FAQ_LIST, payload: response.data });
      if (response.data.success == false) {
        toast.error(
          response.data.message?.original?.message
            ? response.data.message?.original?.message
            : response.data?.message
        );
      } else {
        toast.success(response.data.message);
        dispatch(
          faqList({
            page_num: "",
            per_page: "10",
            search: "",
          })
        );
      }
      return response
    } catch (error) {
      dispatch({ type: FAQ_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const faqDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}faq/get/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: FAQ_DETAIL, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: FAQ_DETAIL, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};
/* done new flow */

export const supportList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}message/list?per_page=${payload?.per_page}&page_num=${payload?.page_num}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: SUPPORT_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: SUPPORT_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const supportShow = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}message/show/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: SUPPORT_SHOW, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: SUPPORT_SHOW, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const supportDetail = (messageId, ticketId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}message/showReplyData/${messageId}/${ticketId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: SUPPORT_DETAIL, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: SUPPORT_DETAIL, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const supportCloseTicket = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}message/closeTicket/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: SUPPORT_CLOSE, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: SUPPORT_CLOSE, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const supportReply = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}message/reply`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: FAQ_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: FAQ_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const rmAdd = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/add`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_LIST, payload: response.data }); // Ensure `response.data` has the correct format
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};
export const rmEdit = (payload, id) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/edit/${id}`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_LIST, payload: response.data }); // Ensure `response.data` has the correct format
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};
export const rmDelete = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/delete/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_LIST, payload: response.data });
      if (response.data.status == false) {
        toast.error(
          response.data.message?.original?.message
            ? response.data.message?.original?.message
            : response.data?.message
        );
      } else {
        toast.success(response.data.message);
        dispatch(
          rmUserList({
            page_num: "",
            per_page: "10",
          })
        );
      }
      return response
    } catch (error) {
      dispatch({ type: RM_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const rmDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/getRecord/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_DETAIL, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_DETAIL, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const rmAssign = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/assign-users`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const rmAssignList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/userList/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_ASSIGN_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_ASSIGN_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const rmBankList = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/relationship-manager/bankList`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: RM_BANK_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: RM_BANK_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const adminMailBack = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/mailback/admin-mailback`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      dispatch({ type: ADMIN_MAILBACK, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_MAILBACK, error: error.message });
      console.error("Error fetching Dashboard Valuation Data:", error.message);
      return error;
    }
  };
};

export const customerStatusList = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/getIINUpdate`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: CUSTOMER_STATUS_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: CUSTOMER_STATUS_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const updateAMCList = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}script/fund-icon-update`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: CUSTOMER_STATUS_LIST, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: CUSTOMER_STATUS_LIST, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const adminEmailUpdate = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/investors/updateEmail`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      dispatch({ type: ADMIN_EMAIL_UPDATE, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_EMAIL_UPDATE, error: error.message });
      console.error("Error fetching Dashboard Valuation Data:", error.message);
      return error;
    }
  };
};

export const adminMobileUpdate = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/investors/updateMobileNo`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      dispatch({ type: ADMIN_MOBILE_UPDATE, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_MOBILE_UPDATE, error: error.message });
      console.error("Error fetching Dashboard Valuation Data:", error.message);
      return error;
    }
  };
};

export const AdminChangePasswordPassword = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}change-password`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_FORGOT_PASSWORD, payload: response.data });
      if (response?.data?.status !== false) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_FORGOT_PASSWORD, error: error.message });
    }
  };
};

export const AddInvestor = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/investors/addNewInvestor`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTOR_ADD, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTOR_ADD, error: error.message });
      return error?.response?.data;
    }
  };
};

export const UpdateInvestor = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/investors/updateInvestor`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTOR_ADD, payload: response.data });
      return response?.data;
    } catch (error) {
      
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTOR_ADD, error: error.message });
      return error?.response?.data;
    }
  };
};

export const InvestorDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/viewInvestorsDetail/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_INVESTOR_DETAIL, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_INVESTOR_DETAIL, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const InvestorAddFormData = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/getAddFormsData`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_ADD_INVESTOR_DATA, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_ADD_INVESTOR_DATA, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const InvestorEditFormData = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/getEditFormsData/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_EDIT_INVESTOR_DATA, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_EDIT_INVESTOR_DATA, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const ResubmitProfileDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/getResubmitProfileData/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_RESUBMIT_PROFILE, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_RESUBMIT_PROFILE, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const ResubmitProfileUcid = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/profile-resubmit/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_RESUBMIT_PROFILE, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_RESUBMIT_PROFILE, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const FatcaDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/fatcaStatus/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_FATCA_DATA, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_FATCA_DATA, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const IINLinkDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/generateIINlink/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_IIN_LINK, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_IIN_LINK, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const FatcaLinkDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/generateFatcaLink/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_FATCA_LINK, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_FATCA_LINK, error: error.message });
      console.error("Error fetching Transaction List:", error.message);
      return error;
    }
  };
};

export const ResubmitProfile = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}admin/investors/resubmitProfile`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTOR_ADD, payload: response.data });
      if (response?.data?.status !== false) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTOR_ADD, error: error.message });
    }
  };
};

export const BrokerDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/check-broker/${payload}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_CHECK_BROKER, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_CHECK_BROKER, error: error.message });
    }
  };
};

export const BankDetailsByIfsc = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/investors/getBankDetailsFromIFSC`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: BANK_DETAIL_IFSC, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: BANK_DETAIL_IFSC, error: error.message });
    }
  };
};

export const GetInvestmentInvestor = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/getInvestors?client_code=${payload?.customerId}&inv_name=${payload?.invName}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTMENT_INVESTOR, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTMENT_INVESTOR, error: error.message });
    }
  };
};

export const GetInvestmentAMC = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/amc-list-for-explore-funds`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTMENT_AMC, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTMENT_AMC, error: error.message });
    }
  };
};

export const GetInvestmentFunds = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/explore-funds`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTMENT_FUND, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTMENT_FUND, error: error.message });
    }
  };
};

export const GetInvestmentCartProductShow = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-show`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_SHOW,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_SHOW,
        error: error.message,
      });
    }
  };
};

export const GetSipData = (payload) => {
  return async (dispatch) => {
    try {
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/sip-data?scheme_code=${payload?.scheme_code}&sip_frequency=${payload?.sip_frequency}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      // dispatch({
      //   type: ADMIN_INVESTMENT_CART_PRODUCT_SHOW,
      //   payload: response.data,
      // });
      return response?.data;
    } catch (error) {
      // dispatch({
      //   type: ADMIN_INVESTMENT_CART_PRODUCT_SHOW,
      //   error: error.message,
      // });
    }
  };
};

export const GetInvestmentCartProductAdd = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-add`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_ADD,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_ADD,
        error: error.message,
      });
    }
  };
};

export const GetInvestmentCartProceed = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-proceed`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_PROCEED,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_PROCEED,
        error: error.message,
      });
    }
  };
};

export const GetInvestmentCartFundDelete = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-delete/${payload?.amc_product_id}`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_DELETE,
        payload: response.data,
      });
      if (response.data.status === false) {
        toast.error(response.data?.message);
      } else {
        toast.success(response.data.message);
        dispatch(GetInvestmentCartProductShow({ user_id: payload?.user_id }));
      }
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_DELETE,
        error: error.message,
      });
    }
  };
};

export const GetInvestmentCartBuy = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-buy`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_BUY,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({
        type: ADMIN_INVESTMENT_CART_PRODUCT_BUY,
        error: error.message,
      });
    }
  };
};

export const GetInvestmentOrder = (payload) => {
  return async (dispatch) => {
    try {
      // Determine base path based on user type
      const basePath = userData?.type === "R" ? "agent" : "admin";
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/orders-details/${payload?.orderId}?user_id=${payload?.userID}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: ADMIN_INVESTMENT_INVESTOR, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: ADMIN_INVESTMENT_INVESTOR, error: error.message });
    }
  };
};

export const dashboardAUMSummary = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}admin/dashboard/aum`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({ type: ADMIN_DASHBOARD_AUM_SUMMARY, payload: response.data });
      return response?.data;
    } catch (error) {
      dispatch({ type: ADMIN_DASHBOARD_AUM_SUMMARY, error: error.message });
      console.error("Error fetching Dashboard Valuation Data:", error.message);
      return error;
    }
  };
};



export const purchaseCart = (payload, type) => {
  return async (dispatch) => {
    try {
      const payloadRequire = {
        amt: payload?.amt,
        id: payload?.id,
        mandate_id: payload?.mandate_id,
        no_netbanking: payload?.no_netbanking,
        no_upi: payload?.no_upi,
        payment_mode: payload?.payment_mode,
        proceed: payload?.proceed,
      };
      const basePath = userData?.type === "R" ? "agent" : "admin";

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-buy`,
        payloadRequire,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      const orderId = [];
      if (response?.data?.transactions?.sip?.length > 0) {
        for (const sipData of response?.data?.transactions?.sip) {
          orderId?.push(sipData?.reg_id);
        }
      }

      if (response?.data?.transactions?.lumpsum?.length > 0) {
        for (const lumpsumData of response?.data?.transactions?.lumpsum) {
          orderId?.push(lumpsumData?.trxn_order_id);
        }
      }

      if (orderId?.length > 0) {
        const payloadProceed = {
          payment_mode: payload?.payment_mode,
          order_ids: orderId?.join(","),
          client_code: payload?.client_code,
          amount: payload?.amt,
          user_id: payload?.id,
          ...((payload?.payment_mode === "NACH" || payload?.payment_mode === "MANDATE" ) && {
            mandate_id: payload?.mandate_id,
          }),
          ...(payload?.payment_mode === "CHEQUE" && {
            bank_account_no: payload?.bank_account_no,
            ifsc: payload?.ifsc,
            cheque_no: payload?.cheque_no,
            cheque_date: payload?.cheque_date,
          }),
          ...(payload?.payment_mode === "UPI" && {
            bank_account_no: payload?.bank_account_no,
            ifsc: payload?.ifsc,
            upi_id: payload?.upi_id,
          }),
          ...(payload?.payment_mode === "NETBANKING" && {
            bank_account_no: payload?.bank_account_no,
            ifsc: payload?.ifsc,
          }),
        };
        if (type !== "s") {
          const response = await axiosInstance.post(
            `${process.env.REACT_APP_API_URL}${basePath}/investments/cart-proceed-payment`,
            payloadProceed,
            {
              headers: {
                Authorization: `${token}`,
              },
            }
          );
          if (response) {
            dispatch(getHeaderCount());
          }

          dispatch({ type: PURCHASE_CART, payload: response.data }); // Ensure `response.data` has the correct format
          return response?.data;
        } else {
          if (response) {
            dispatch(getHeaderCount());
          }
          dispatch({ type: PURCHASE_CART, payload: response.data }); // Ensure `response.data` has the correct format
          return response?.data;
        }
      } else {
        dispatch({ type: PURCHASE_CART, payload: response.data }); // Ensure `response.data` has the correct format
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching FAQ's data", error.message);
    }
  };
};
